<div class="d-flex flex-column gap-2 m-4">
  <div>{{ notification.title }}</div>
  <div [innerHTML]="notification.message | safeHtml"></div>
  <div class="d-flex justify-content-end">
    <app-button (onChangeClick)="readNot()">{{ 'read' | translate }}</app-button>
  </div>
</div>
